import { Component, Vue, Prop } from 'vue-property-decorator';

import { ImageResourceDTO } from '../../model/ImageResourceDTO';
import { GalleryItem } from '../gallery-item/gallery-item';

import "swiper/dist/css/swiper.css";

@Component({
	components: {
		GalleryItem
	}
})
export class Gallery extends Vue {
	@Prop() items: ImageResourceDTO[][];
	@Prop() sizes: string;
	@Prop() itemsPerView?: number[];
	@Prop() description: boolean;

	options = {
		slidesPerView: this.itemsPerView ? this.itemsPerView[3] : 3,
		spaceBetween: 0,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev'
		},
		breakpoints: {
			1200: {
				slidesPerView: this.itemsPerView ? this.itemsPerView[3] : 3,
			},
			992: {
				slidesPerView: this.itemsPerView ? this.itemsPerView[2] : 3,
			},
			768: {
				slidesPerView: this.itemsPerView ? this.itemsPerView[1] : 3,
			},
			576: {
				slidesPerView: this.itemsPerView ? this.itemsPerView[0] : 3,
			}
		}
	};
}

export default Gallery;
